import { propIn } from '../../../common/utils/immutableHelper';
import { ImElementLocalData } from './elementLocalDataTypes';

export const getLocalError: (data: ImElementLocalData) => string | null = propIn(['error']);
export const getLocalShouldLoadPreview: (data: ImElementLocalData) => string | null = propIn(['shouldLoadPreview']);
export const getLocalUrl: (data: ImElementLocalData) => string = propIn(['url']);

export const getLocalHidden: (data: ImElementLocalData) => boolean = propIn(['hidden']);
